import React, { useState } from 'react';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonTextarea,
  IonTitle,
  IonToast,
  IonToolbar,
} from '@ionic/react';
import { createTicketPaymentRequest } from '../services/ticket.service';

interface IProps {
  ticketId: string;
  isOpen: boolean;
  onClose: () => void;
  onCreated: () => void;
}

const CreateTicketPaymentRequest: React.FC<IProps> = ({ ticketId, isOpen, onClose, onCreated }) => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const reset = () => {
    setAmount('');
    setDescription('');
    setError('');
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = async () => {
    const amt = Number(amount);
    if (!amt || amt <= 0) { setError('Enter a valid amount'); return; }
    if (!description.trim()) { setError('Description is required'); return; }

    setLoading(true);
    try {
      await createTicketPaymentRequest(ticketId, { amount: amt, description: description.trim() });
      reset();
      onCreated();
      onClose();
    } catch {
      setError('Failed to create payment request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <IonModal isOpen={isOpen} onDidDismiss={handleClose}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Request Payment</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={handleClose}>Close</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonItem>
            <IonLabel position="stacked">Amount (₹)</IonLabel>
            <IonInput
              type="number"
              value={amount}
              onIonChange={e => setAmount(e.detail.value ?? '')}
              placeholder="e.g. 500"
              min="1"
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Description</IonLabel>
            <IonTextarea
              value={description}
              onIonChange={e => setDescription(e.detail.value ?? '')}
              placeholder="e.g. Visiting charges"
              rows={3}
            />
          </IonItem>
          <IonButton
            expand="block"
            className="ion-margin-top"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Creating...' : 'Create Payment Request'}
          </IonButton>
        </IonContent>
      </IonModal>

      <IonToast
        isOpen={!!error}
        onDidDismiss={() => setError('')}
        message={error}
        duration={2500}
        color="danger"
      />
    </>
  );
};

export default CreateTicketPaymentRequest;
